import { LockIcon } from "@chakra-ui/icons";
import { Box, Center, Text, VStack } from "@chakra-ui/react";

// Mirrors the mobile ComicQuickAction: a circular icon button with its label
// underneath, and a padlock badge once the action is locked behind Premium.
const ComicQuickAction = ({ icon, label, onClick, color, isDisabled }) => (
  <VStack
    as="button"
    type="button"
    aria-label={label}
    aria-disabled={isDisabled || undefined}
    disabled={isDisabled}
    onClick={isDisabled ? undefined : onClick}
    flex="1"
    px="2px"
    spacing="0"
    cursor={isDisabled ? "not-allowed" : "pointer"}
  >
    <Center
      position="relative"
      w="40px"
      h="40px"
      borderWidth="1px"
      borderRadius="full"
      borderColor={isDisabled ? "#3C3C3C" : "#30384E"}
      bg={isDisabled ? "#171717" : "#1A2138"}
      color={isDisabled ? "#8F9BB3" : color || "#F7F9FC"}
      fontSize="22px"
      _hover={isDisabled ? undefined : { bg: "#222B45" }}
    >
      {icon}
      {isDisabled && (
        <Center
          position="absolute"
          right="-4px"
          bottom="-3px"
          w="20px"
          h="20px"
          borderRadius="full"
          bg="#FFAA00"
        >
          <LockIcon color="#101426" boxSize="10px" />
        </Center>
      )}
    </Center>
    <Box mt="6px">
      <Text
        color={isDisabled ? "#6F6F6F" : "#A8B2C8"}
        textAlign="center"
        fontSize="9px"
        lineHeight="13px"
        fontWeight="700"
        letterSpacing="0.5px"
      >
        {label}
      </Text>
    </Box>
  </VStack>
);

export default ComicQuickAction;
